<template>
	<div>
		<div class="text">
			<template v-for="(text, key) in splitUnicode(content)">
				<span v-if="!isEmoji(text)" :key="key" v-html="text" />
				<Emoji v-else :key="key" :emoji="unemojify(text)" :size="20" class="emoji" />
			</template>
		</div>
		<div class="translated-text" v-if="translatedText">
			<span class="translated-text-title">{{ $t("chatMessageText.translateText") }}:</span>
			<template v-for="(text, key) in splitUnicode(translatedText)">
				<span v-if="!isEmoji(text)" :key="key" v-html="text" />
				<Emoji v-else :key="key" :emoji="unemojify(text)" :size="20" class="emoji" />
			</template>
		</div>
	</div>
</template>

<script>
import { Emoji } from "emoji-mart-vue";

import emojiRegex from "emoji-regex";

import nodeEmoji from "node-emoji";

import * as _ from "lodash";

const regex = emojiRegex();

export default {
	name: "ChatMessageText",

	props: ["content", "translatedText"],

	components: {
		Emoji,
	},

	created: () => {
		// console.log(this.content);
	},

	methods: {
		// 分割unicode字符，并且\n转为<br />
		splitUnicode(text) {
			return _.map(_.split(text, ""), (str) => str.replace(/\n/g, "<br />"));
		},

		// 是否为emoji字符
		isEmoji(text) {
			return !!text.match(regex);
		},

		// 解析emoji字符
		unemojify(text) {
			return nodeEmoji.unemojify(text);
		},
	},
};
</script>

<style lang="less" scoped>
.text {
	// word-break: break-all;
	word-break: break-word;
	// white-space: pre-line;
}
.translated-text {
	word-break: break-word;
	margin-top: 10px;
}

.emoji {
	margin-left: 2px;
	margin-right: 2px;
}
</style>
